module.exports = __webpack_public_path__ + "table-sort-asc.97d937402dd0c9b0bcd2a49010a0fac3.png";